<template>
  <stat-total-circle :data="circle_data" :colors="circle_colors">
    <span slot="title">{{ $t('pbx.stat.common.field.total') }}</span>
    <span slot="amount">{{ total.total | format }}</span>
  </stat-total-circle>
</template>

<script>
  import StatTotalCircle from '@shared/components/stats-chart-cicle-total';
  import { green, red, yellow, purple, crimson } from '@shared/helpers/css';

  export default {
    components: {
      StatTotalCircle
    },
    filters: {
      format: function(val) {
        return parseInt(val).toLocaleString();
      }
    },
    props: {
      total: {
        type: Object,
        default: function() {
          return {
            answered: 0,
            no_answer: 0,
            canceled: 0,
            rejected: 0,
            failed: 0
          };
        }
      }
    },
    computed: {
      circle_data() {
        return [
          ['', ''],
          ['', this.total.answered],
          ['', this.total.no_answer],
          ['', this.total.canceled],
          ['', this.total.rejected],
          ['', this.total.failed]
        ];
      },
      circle_colors() {
        return [green, yellow, crimson, purple, red];
      }
    }
  };
</script>
